<template>

    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>{{ dish.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CNav variant="tabs">
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}`">
                            Карточка
                        </CNavItem>
                        <CNavItem active v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)">
                            Редактировать
                        </CNavItem>
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/ingredient-groups`">
                            Группы ингредиентов
                        </CNavItem>
                        <CNavItem :to="`/restaurants/${restaurant.id}/dishes/${dish.id}/modifier-groups`">
                            Группы модификаторов
                        </CNavItem>
                    </CNav>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <label>Название <span class='label' > * </span></label>
                        <CInput
                            v-model="dish.title"
                            placeholder="Введите название блюда"
                        />
                        <DishScheduleEditor
                            v-if="dish.id"
                            :restaurant-id="dish.restaurant_id"
                            :dish-id="dish.id"
                            :schedules="dishSchedules"
                            @saved="dishSchedules = $event" />
                        <CRow class="pl-3 pb-3">Лейблы</CRow>
                        <CRow class="pl-3 pb-3">
                            <CCol sm="12">
                            <div v-for="label in allLabels" :key="label.id" class="form-check">
                                <input 
                                class="form-check-input"
                                type="checkbox"
                                :id="`label-${label.id}`"
                                :value="label.id"
                                v-model="selectedLabels"
                                />
                                <label class="form-check-label" :for="`label-${label.id}`">
                                    {{ label.title }}
                                </label>
                            </div>
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3">Категории</CRow>
                        <CRow class="pl-3 pb-3">
                            <CCol sm="4">
                                <CSelect
                                    horizontal
                                    :options="categoriesOptions"
                                    :value.sync="selectedCategory"
                                    placeholder="Выберите категорию..."
                                />
                            </CCol>
                            <CCol sm="8">
                                <CButton
                                    color="primary"
                                    class="ml-3"
                                    @click="addCategory">Добавить</CButton>
                            </CCol>
                        </CRow>
                        <CRow class="pl-3">
                            <table class="table">
                                <draggable v-model="categories" tag="tbody">
                                    <tr v-for="category in categories" :key="category.title">
                                        <td><CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" /></td>
                                        <td>{{ category.title }}</td>
                                        <td><CButton @click="removeCategory(category.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                    </tr>
                                </draggable>
                            </table>
                        </CRow>
                        <CRow class="pl-3 pb-3">Скидка</CRow>
                        <CRow class="pl-3 pb-3">
                            <CCol sm="4">
                                <CSelect
                                    horizontal
                                    :options="promotionsOptions"
                                    :value.sync="selectedPromotion"
                                    placeholder="Выберите скидку..."
                                />
                            </CCol>
                        </CRow>
                        <div id="product-picture">
                        <CRow v-if="dish.picture">
                            <CCol sm="3" class="col-form-label">&nbsp;</CCol>
                            <CCol sm="6" class="col-form-label"><CImg
                                :src="pictureUrl"
                                class="m2"
                                width="200" /></CCol>
                            <CCol sm="3" class="col-form-label">
                                <CButton
                                    color="danger"
                                    class="ml-3"
                                    @click="deletePicture(dish.picture)">Удалить</CButton>
                            </CCol>
                        </CRow>


                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"
                        />
                        </div>
                        <CTextarea
                            v-model="dish.description"
                            label="Описание"
                            placeholder="Краткое описание блюда (не более 255 символов)"
                        />
                        <CInput
                            v-model="dish.quantity"
                            label="Количество (шт)"
                        />
                        <CInput
                            v-model="dish.composition"
                            label="Состав"
                            placeholder="Состав блюда (не более 255 символов)"
                        />
                        <CInput
                            v-model="dish.allergens"
                            label="Содержит"
                            placeholder="Аллергены, если есть (не более 255 символов)"
                        />
                        <label>Цена <span class='label' > * </span></label>
                        <CInput
                            v-model="dish.price"
                        />

                        <CSelect
                            :value.sync="dish.vat"
                            :horizontal="true"
                            :options="vatOptions"
                            label="Значения ставки НДС"
                            placeholder="Выберите значения ставки НДС"
                        />

                        <CSelect
                            label="Единицы измерения"
                            :options="unitsOptions"
                            :value.sync="dish.units"
                            placeholder="Выберите единицы измерения..."
                        />

                        <CInput v-model="dish.weight" :label="`Вес (${UNITS_ENUM[dish.units]})`" />

                        <CInput
                            v-model="dish.calories"
                            label="Килокалории (ккал)"
                        />
                        <CInput
                            v-model="dish.protein"
                            label="Белки"
                            step="0.1"
                        />
                        <CInput
                            v-model="dish.fat"
                            label="Жиры"
                            step="0.1"
                        />
                        <CInput
                            v-model="dish.carbohydrates"
                            label="Углеводы"
                            step="0.1"
                        />

                        <div
                            v-if="restaurant.show_in_table_orders"
                            class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4"
                        >
                            <CRow class="pl-3 pb-3">
                                <strong>Интервалы доставки</strong>
                            </CRow>
                            <p class="text-muted pl-3">
                                Если ничего не выбрано, блюдо доступно в любой интервал.
                            </p>
                            <label
                                v-for="interval in shopIntervals"
                                :key="interval.id"
                                class="d-block pl-3"
                            >
                                <input
                                    v-model="shopIntervalIds"
                                    type="checkbox"
                                    :value="interval.id"
                                >
                                {{ interval.label }}
                            </label>
                        </div>

                        <div
                            v-if="restaurant.show_in_table_orders"
                            class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4"
                        >
                            <CRow class="pl-3 pb-3">
                                <strong>Подкатегории</strong>
                            </CRow>
                            <div
                                v-for="category in shopCategories"
                                :key="category.id"
                                class="mb-3 pl-3"
                            >
                                <div>
                                    <strong>{{ category.title }}</strong>
                                    <span v-if="category.mapped" class="text-muted"> — категория блюда</span>
                                </div>
                                <label
                                    v-for="subcategory in category.subcategories"
                                    :key="subcategory.id"
                                    class="d-block"
                                >
                                    <input
                                        v-model="shopSubcategoryIds"
                                        type="checkbox"
                                        :value="subcategory.id"
                                    >
                                    {{ subcategory.title }}
                                </label>
                                <div class="form-inline mt-1">
                                    <input
                                        v-model="newSubcategoryTitles[category.id]"
                                        class="form-control form-control-sm mr-2"
                                        placeholder="Новая подкатегория"
                                    >
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-primary"
                                        @click="createShopSubcategory(category.id)"
                                    >
                                        Создать
                                    </button>
                                </div>
                            </div>
                        </div>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Энергетик (18+)
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="dish.energetic"
                                />
                                <small class="form-text text-muted">
                                    Отметьте, если товар является энергетиком или требует подтверждения возраста 18+
                                </small>
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Популярное блюдо
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="dish.popular"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Приоритет в выдаче в популярном
                            </CCol>
                            <CCol sm="3">
                                <CInput
                                    v-model="dish.priority"
                                    placeholder="Приоритет"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="dish.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter v-if="(!restaurant.alias && adminOnly) || (!restaurant.alias && !adminOnly) || (restaurant.alias && adminOnly) || (restaurant.alias && adminOnly)">
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="deleteModal = true">Удалить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить блюдо? Это действие нельзя будет отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="deleteDish">Удалить</CButton>
                </div>
            </template>
        </CModal>

    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';
    import { UNITS_ENUM } from '@/utils/units';
    import { focusProductPicture } from '@/utils/focusPicture';
    import DishScheduleEditor from '@/components/dish-schedule-editor.vue';

    export default {

        name: 'DishEdit',

        components: {
            draggable,
            DishScheduleEditor
        },

        icons: {
            cilCursorMove,
            cilTrash
        },

        data () {
            return {
                restaurant: {},
                dish: {},
                dishSchedules: [],
                selectedPicture: null,
                deleteModal: false,
                categories: [],
                allCategories: [],
                promotions: [],
                selectedCategory: null,
                selectedPromotion: null,
                UNITS_ENUM,
                allLabels: [],
                selectedLabels: [],
                shopIntervals: [],
                shopIntervalIds: [],
                shopCategories: [],
                shopSubcategoryIds: [],
                newSubcategoryTitles: {},
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                ],
            }
        },

        computed: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
            pictureUrl() {
                if(this.dish.picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.dish.picture;
                } else {
                    return '';
                }
            },

            categoriesOptions: function() {
                const categoriesOptions = [];
                this.allCategories.forEach(category => {
                    categoriesOptions.push({
                        value: category.id,
                        label: category.title
                    });
                });
                return categoriesOptions;
            },
            promotionsOptions: function() {
                const promotionsOptions = [];
                this.promotions.forEach(promotion => {
                     if(promotion.enabled && promotion.delivery_type === null) {
                        promotionsOptions.push({
                            value: promotion.id,
                            label: promotion.title
                    });
                     }
                });
                promotionsOptions.push({
                    value: 'null',
                    label: 'Без скидки',
                })
                return promotionsOptions;
            },
            unitsOptions() {
                return Object.entries(UNITS_ENUM).map(([value, label]) => ({ value: +value, label }));
            },
        },

        mounted() {
            focusProductPicture(this.$route);
            const id = parseInt(this.$route.params.id);
            const dish_id = parseInt(this.$route.params.dish_id);
            Vue.axios.get('/common-promotions')
                .then(resp => {
                    this.promotions = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных.  \n\n${err.response.data.error}`);
                });
            Vue.axios.get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных.  \n\n${err.response.data.error}`);
                });
            Vue.axios.get('/restaurants/' + id + '/dishes/' + dish_id)
                .then(resp => {
                    const { schedules, ...dish } = resp.data;
                    this.dish = dish;
                    this.dish.protein = this.formatMacro(dish.protein);
                    this.dish.fat = this.formatMacro(dish.fat);
                    this.dish.carbohydrates = this.formatMacro(dish.carbohydrates);
                    this.dishSchedules = schedules || [];
                    this.selectedLabels = this.dish.labels || [];

                    if(this.dish.promotion_id){
                        this.selectedPromotion = this.dish.promotion_id;
                    } else {
                        this.selectedPromotion = 'null';
                    }
                })
                .catch(err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных.  \n\n${err.response.data.error}`);
                });

            Vue.axios.get('/restaurants/' + id + '/dishes/get-categories/' + dish_id)
                .then(resp => {
                    this.categories = resp.data;
                })
                .catch( err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных.  \n\n${err.response.data.error}`);
                });
            Vue.axios.get(`/restaurants/${ id }/categories/`)
                .then(resp => {
                    this.setAllCategories(resp.data);
                })
                .catch( err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных.  \n\n${err.response.data.error}`);
                });

            Vue.axios.get('/shop-catalog/dishes/' + dish_id)
                .then(({ data }) => {
                    this.shopIntervals = data.intervals || [];
                    this.shopIntervalIds = data.selected_interval_ids || [];
                    this.shopCategories = data.categories || [];
                    this.shopSubcategoryIds = data.selected_subcategory_ids || [];
                    for (const category of this.shopCategories) {
                        if (this.newSubcategoryTitles[category.id] == null) {
                            this.$set(this.newSubcategoryTitles, category.id, '');
                        }
                    }
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Не удалось загрузить интервалы и подкатегории.');
                });

            Vue.axios.get('/labels')
                .then(response => {
                    this.allLabels = response.data;
                })
                .catch(error => {
                    console.log(error, 'error');
                    
                    this.$root.$emit('showError', 'Ошибка при загрузке лейблов.');
                });
        },

        methods: {
            formatMacro(value) {
                const n = Number(value);
                if (!Number.isFinite(n)) return '0.0';
                return (Math.round((n + Number.EPSILON) * 10) / 10).toFixed(1);
            },
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            saveShopCatalog() {
                return Vue.axios.put('/shop-catalog/dishes/' + this.dish.id, {
                    interval_ids: this.shopIntervalIds,
                    subcategory_ids: this.shopSubcategoryIds
                });
            },

            createShopSubcategory(categoryId) {
                const title = (this.newSubcategoryTitles[categoryId] || '').trim();
                if (!title) return;

                Vue.axios.post(`/shop-catalog/categories/${categoryId}/subcategories`, { title })
                    .then(({ data }) => {
                        const category = this.shopCategories.find(item => item.id === categoryId);
                        if (category) {
                            category.subcategories = category.subcategories || [];
                            if (!category.subcategories.some(item => item.id === data.id)) {
                                category.subcategories.push(data);
                            }
                        }
                        if (!this.shopSubcategoryIds.includes(data.id)) {
                            this.shopSubcategoryIds.push(data.id);
                        }
                        this.$set(this.newSubcategoryTitles, categoryId, '');
                    })
                    .catch(err => {
                        this.$root.$emit('showError', err.response?.data?.error || 'Не удалось создать подкатегорию');
                    });
            },

            save() {
                if(!this.dish.title) {
                    this.$root.$emit('showError', 'Укажите название блюда.');
                    return;
                }
                if(!this.dish.price) {
                    this.$root.$emit('showError', 'Укажите стоимость.');
                    return;
                }
                if(!this.dish.weight) {
                    this.dish.weight = null;
                }
                if(!this.dish.calories) {
                    this.dish.calories = 0;
                }
                if (!this.dish.carbohydrates) {
                    this.dish.carbohydrates = 0;
                }
                if (!this.dish.protein) {
                    this.dish.protein = 0;
                }
                if (!this.dish.fat) {
                    this.dish.fat = 0
                };
                if(!this.dish.quantity) {
                    this.dish.quantity = null;
                }
                if(this.selectedPromotion) {
                    this.dish.promotion_id = this.selectedPromotion;
                }
                if(this.categories.length === 0) {
                    this.$root.$emit('showError', 'Укажите категорию блюда.');
                    return;
                }

                this.dish.labels = this.selectedLabels;

                this.dish.composition = this.dish.composition ? String(this.dish.composition) : '';
                this.dish.allergens = this.dish.allergens ? String(this.dish.allergens) : '';
                this.dish.weight = this.dish.weight ? +this.dish.weight : '';
                this.dish.calories = this.dish.calories ? +this.dish.calories : '';
                this.dish.fat = this.dish.fat ? +String(this.dish.fat).replace(',', '.') : '';
                this.dish.carbohydrates = this.dish.carbohydrates ? +String(this.dish.carbohydrates).replace(',', '.') : '';
                this.dish.protein = this.dish.protein ? +String(this.dish.protein).replace(',', '.') : '';
                this.dish.quantity = this.dish.quantity ? +this.dish.quantity : '';
                this.dish.vat = this.dish.vat ? +this.dish.vat : null;
                this.dish.title = this.dish.title ? String(this.dish.title) : '';
                this.dish.description = this.dish.description ? String(this.dish.description) : '';
                this.dish.energetic = !!this.dish.energetic;
                this.dish.popular = !!this.dish.popular;
                this.dish.enabled = !!this.dish.enabled;
                this.dish.table_order_breakfast = !!this.dish.table_order_breakfast;
                this.dish.table_order_lunch = !!this.dish.table_order_lunch;
                this.dish.table_order_dinner = !!this.dish.table_order_dinner;
                this.dish.table_order_snack = !!this.dish.table_order_snack;


                if(this.selectedPicture) {
                    // Загружаем картинку
                    let formData = new FormData();
                    formData.append('file', this.selectedPicture);
                    Vue.axios.post('/files/upload', formData)
                        .then(resp => {
                            // Если все хорошо - сохраняем блюдо
                            this.dish.picture = resp.data.filename;
                            Vue.axios.post('/restaurants/' + this.restaurant.id + '/dishes/update/' + this.dish.id, this.dish)
                                .catch(err => {
                                    this.$root.$emit('showError', `Ошибка сохранения. \n\n${err.response.data.error}`);
                                });
                        })
                        .catch(err => {
                            this.$root.$emit('showError', `Ошибка загрузки файла.  \n\n${err.response.data.error}`);
                        });
                } else {
                    Vue.axios.post('/restaurants/' + this.restaurant.id + '/dishes/update/' + this.dish.id, this.dish)
                        .catch(err => {
                            this.$root.$emit('showError', `Ошибка сохранения. \n\n${err.response.data.error}`);
                        });
                }

                const categoriesToSave = [];
                let index = 0;
                this.categories.forEach(category => {
                    category.position = ++index;
                    categoriesToSave.push(category);
                });
                Vue.axios.post('/restaurants/' + this.restaurant.id +'/dishes/categories/' + this.dish.id, { categories: categoriesToSave })
                    .then(() => this.saveShopCatalog())
                    .then(() => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка сохранения. \n\n${err.response.data.error}`);
                    });
            },

            deleteDish() {
                Vue.axios.delete('/restaurants/' + this.restaurant.id + '/dishes/' + this.dish.id)
                    .then(() => {
                        this.$router.push({ path: '/restaurants/' + this.restaurant.id + '/dishes' })
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка удаления. \n\n${err.response.data.error}`);
                    });
            },

            deletePicture(url) {
                Vue.axios.delete(`/files/delete?filename=${url}`)
                    .then(() => {
                        this.dish.picture = '';
                        Vue.axios.post('/restaurants/' + this.restaurant.id + '/dishes/update/' + this.dish.id, this.dish)
                            .catch(err => {
                                this.$root.$emit('showError', `Ошибка сохранения. \n\n${err.response.data.error}`);
                            });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка удаления. \n\n${err.response.data.error}`);
                    });
            },

            setAllCategories(categories) {
                const _allCategories = [];
                categories.forEach(category => {
                    if(this.addCategoryOption(category.id)) {
                        _allCategories.push({
                            id: category.id,
                            title: category.title
                        });
                    }
                });
                this.allCategories = _allCategories;
            },


            addCategoryOption(id) {
                let contains = false;
                for(var i = 0; i < this.categories.length; i++) {
                    if(this.categories[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addCategory() {
                for(var i = 0; i < this.allCategories.length; i++) {
                    if(this.selectedCategory === this.allCategories[i].id) {
                        this.categories.push({
                            id: this.allCategories[i].id,
                            title: this.allCategories[i].title,
                            position: 0
                        });
                        delete this.allCategories[i];
                        break;
                    }
                }
                this.setAllCategories(this.allCategories);
            },

            removeCategory(id) {
                const _categories = [];
                for(var i = 0; i < this.categories.length; i++) {
                    if(id != this.categories[i].id) {
                        _categories.push(this.categories[i]);
                    }
                }
                this.categories = _categories;
            },

            goBack() {
                this.$router.push({ path: '/restaurants/' + this.restaurant.id + '/dishes/' + this.dish.id });
            }
        }
    }

</script>
<style scoped lang="scss">

.handle {
  cursor: pointer;
}
.label
    {
    color: red;
    font-size: 150%
    }
</style>
